import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/store/product-group",
        component: List,
        name: "store.product.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/product-group/create",
        component: Create,
        name: "store.product.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/product-group/:id/edit",
        component: Edit,
        name: "store.product.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
